import Basic from '@rebuild/materials/shared/history_nav/BaseHistoryNav.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/history_nav/context';

function useSelfContext() {
	const formattedNavTitle = nav => nav.name;

	provideCurrentContext({
		formattedNavTitle
	});
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext)
};
